export const AUTH_ACCEPT_INVITATION = 'AUTH_ACCEPT_INVITATION';
export const AUTH_ACCEPT_INVITATION_SUCCESS = 'AUTH_ACCEPT_INVITATION_SUCCESS';
export const AUTH_ACCEPT_INVITATION_FAILED = 'AUTH_ACCEPT_INVITATION_FAILED';
